import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { ViewState } from "../../../common/config/AppConstants";
import * as format from "../../../common/FormatFunctions";
import { ListValueDisplay } from "../../Common/ListValueDisplay";

export class LocationDisplay extends React.Component {
  render() {
    var bean = this.props.data;
    if (!format.isNotNull(bean)) {
      return <div></div>;
    }
    return (
      <div>
        <div
          className="ui-g-12 card-round"
          onClick={e => {
            if (format.isFunction(this.props.onClick)) {
              this.props.onClick(bean);
            }
          }}
        >
          <div className="ui-g-12">
            {/*Empty div for spacing*/}
            <label />
          </div>
          <div className="ui-g-12">
            <div className="ui-g-4">
              <b>Location Name: </b>
              <label>{bean.name || "Not Set"}</label>
            </div>
            <div className="ui-g-4">
              <b>Floor Number: </b>
              <label>{bean.floor || "Not Set"}</label>
            </div>
            <div className="ui-g-4">
              <b>Area: </b>
              <label>{bean.area || "Not Set"}</label>
            </div>
          </div>
          <div className="ui-g-12">
            <div className="ui-g-4">
              <b>Contact Telephone: </b>
              <label>{bean.telephone || "Not Set"}</label>
            </div>
            <div className="ui-g-4">
              {/*Empty div for spacing*/}
              <label />
            </div>
            <div className="ui-g-4">
              <b>Email: </b>
              <label>{bean.email || "Not Set"}</label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sites/UI/LocationDisplay.js